export const formatInputDateValue = (date: Date): string => {
  return date.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatDateRange = (rangeStart?: Date, rangeEnd?: Date): string => {
  const rangeStartString = rangeStart ? formatInputDateValue(rangeStart) : "";
  const rangeEndString = rangeEnd ? formatInputDateValue(rangeEnd) : "";
  const showDelimiter = !!rangeStart;

  return `${rangeStartString}${showDelimiter ? "-" : ""}${rangeEndString}`;
};
